"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSupportedAuthApiRoutePath = isSupportedAuthApiRoutePath;
const constant_1 = require("../constant");
function isSupportedAuthApiRoutePath(path) {
    return constant_1.SUPPORTED_ROUTES.includes(path);
}
